import { render, staticRenderFns } from "./joiner_product_edit.vue?vue&type=template&id=d84961be&scoped=true&"
import script from "./joiner_product_edit.vue?vue&type=script&lang=js&"
export * from "./joiner_product_edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d84961be",
  null
  
)

export default component.exports